export default "__VITE_ASSET__Cz9$C8h4__"